module.exports = __webpack_public_path__ + "static/media/landing.1c27c683.png";